export const BACKEND_HOSTNAME = 'https://react-learnwords-36.herokuapp.com'
export const URL_WORDS = 'words'
export const URL_USERS = 'users'
export const URL_SIGNIN = 'signin'
export const URL_TOKENS = 'tokens'
export const URL_STATISTICS = 'statistics'
export const URL_AGREGATED = 'aggregatedWords'

export default BACKEND_HOSTNAME
